<template>
  <div class="flex flex-col" v-loading="loading">
    <p class="text-primary-yellow text-lg mb-3" v-if="this.$route.name !== 'EditGroup'">Add Members</p>

    <!-- <div class="flex justify-start gap-4">
      <div v-for="user in selectedUsers" :key="user.id" class="flex flex-col items-center">
        <div
          class="imagePreviewWrapper"
          :style="{
            'background-image': 'url(' + require('@/assets/images/auth/user.jpg') + ')'
          }"
        >
          <span class="img-fluid img-upload-icon" @click="removeUser(user)">
            <svg
              width="25"
              height="25"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM8.00066 14.5455C11.6156 14.5455 14.5461 11.615 14.5461 8.00001C14.5461 4.38506 11.6156 1.45456 8.00066 1.45456C4.38571 1.45456 1.45521 4.38506 1.45521 8.00001C1.45521 11.615 4.38571 14.5455 8.00066 14.5455ZM5.60456 11.4234L7.99939 9.02856L10.3942 11.4234L11.4227 10.3949L9.02791 8.00004L11.4227 5.60521L10.3942 4.57669L7.99939 6.97152L5.60456 4.57669L4.57604 5.60521L6.97087 8.00004L4.57604 10.3949L5.60456 11.4234Z"
                fill="#383F51"
              />
            </svg>
          </span>
        </div>
        <p class="">{{user.fname}}</p>
      </div>
    </div> -->
    
    <hr class="my-2" />
    <p class="block my-3">{{filteredUsers.length > 0 ? filteredUsers.length : 'no'}} members</p>
    <!-- <h3 class="mt-4 mb-3 text-lg">All Users</h3> -->
    <div v-if="this.$route.name !== 'EditGroup'" class="table__search-input-wrapper mb-2">
      <span class="pr-2 opacity-50"><search-icon /> </span>
      <input
        type="text"
        class="table__search-input"
        placeholder="Search and add Members from here "
        v-model="filterQuery"
      />
      <img src="@/assets/images/icons/search.svg" alt="search icon" />
    </div>

    <div class="grid grid-cols-2 gap-2  overflow-y-scroll" style="max-height:12rem">
      <div 
        v-for="user in filteredUsers" :key="user.id"
        class="flex justify-between items-center p-2 m-2 rounded-lg"
        style="border: 1px dashed gray"
      >
        <div class="flex gap-2">
          <img
            src="@/assets/images/auth/user.jpg"
            class="w-12 h-12 rounded-full"
            alt="search icon"
          />
          <div class="flex flex-col">
            <a href="#" @click.prevent="selectUser(user)"  style="color:black;">
              <h3 class="font-bold text-sm">
                {{ user.fname+" "+user.lname }}
              </h3>
            </a>
            <small class="text-gray-500">{{ user.orgFunction ? user.orgFunction.name: "Not Assigned" }}</small>
          </div>
        </div>
        <div  class="flex flex-col gap-0">
          <small class="text-gray-500">Add User as:</small>
          <span class="">
            <base-checkbox
              label="ADMIN"
              :modelValue="user.isAdmin"
              @change="adminCheckbox(user)"
          /></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCheckbox from "@/components/UI/BaseCheckbox";
export default {
  components: {
    BaseCheckbox,
  },
  props: ["creatingGroup", "isButtonDisabled", "refreshGroups"],
  data() {
    return {
      users: [
        {
          id: 1,
          fname: "Jaiden",
          lname: "Femi",
          role: "Operations Manager",
          isAdmin: true,
        },
        {
          id: 2,
          fname: "Ruka",
          lname: "kafaya",
          role: "software Manager",
          isAdmin: true,
        },
        {
          id: 3,
          fname: "Funmi",
          lname: "Femi",
          role: "security",
          isAdmin: true,
        },
        {
          id: 4,
          fname: "Funmi",
          lname: "Femi",
          role: "security",
          isAdmin: true,
        },
        {
          id: 5,
          fname: "Funmi",
          lname: "Femi",
          role: "security",
          isAdmin: true,
        },
      ],
      selectedUsers: [],
      selectedUser: {},
      showOptions: false,
      role: "",
      roles: [],
      filterQuery: "",
      loading: false,
    };
  },
  computed: {
    filteredUsers() {
      // return this.users.filter(
      //   (user) =>
      //     user.name.toUpperCase().indexOf(this.filterQuery.toUpperCase()) > -1
      // );
      return this.users;
    },
  },
  mounted() {
    this.getUsers();
    // this.getAllRoles();
  },
  watch: {
    refreshGroups() {
      if (this.refreshGroups) {
        this.selectedUsers = [];
      }
    },
  },
  methods: {
    adminCheckbox(user){
      user.isAdmin = !user.isAdmin
    },
    async getAllRoles() {
      try {
        let response = await this.$_getRoles();
        console.log(response);
        this.roles = response.data.roles;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getUsers() {
      try {
        let response = await this.$_getAllUsers();
        console.log(response);
        this.users = response.data;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    selectUser(user) {
      this.selectedUser.id = user.id;
        // let fe = keyboard.homeShapeShift.map(k => k.filter(e => e.text !== 'ZEC'));
      // if(!this.selectedUsers.includes(modUser)){
        //   this.selectedUsers.push(modUser);
      // }
      let userIndex = this.selectedUsers.indexOf(user);
      if (userIndex < 0) {
        this.selectedUsers.push(user);
        let userData = {
          userId: user.id,
          isAdmin: user.isAdmin
        };
        this.$emit("select-user", userData);
      }
      // this.$emit("select-user", this.selectedUsers);
      this.showOptions = false;
    },
    removeUser(user) {
      this.$emit("remove-user", user.id);
      let userIndex = this.selectedUsers.indexOf(user);
      this.selectedUsers.splice(userIndex, 1);
      console.log(this.selectedUsers," grpm m remove user ")

    },
  },
};
</script>

<style scoped lang="scss">
.imagePreviewWrapper {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  background-image: url("../../../assets/images/settings/blank-profile-picture.png");
  margin: 0 auto;
  background-size: cover;
  background-position: center center;
}
.img-upload-icon {
  position: absolute;
  right: 0;
  top: 70%;
}
.file-input {
  display: none;
}
</style>